import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import { RowHelper } from "util/TableHelper";
import AccountTransactionRuleAddForm from "../Forms/AccountTransactionRuleAddForm";
import AccountTransactionRuleUpdateForm from "../Forms/AccountTransactionRuleUpdateForm";
import AccountTransactionRuleListFilter from "../Filters/AccountTransactionRuleListFilter";

const AccountTransactionRuleList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "KURAL LİSTESİ" });
  const [accountTransactionRules, setAccountTransactionRules] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isUseForErp, setIsUseForErp] = useState(false);

  const history = useHistory();

  useEffect(() => {
    checkForUseErp();
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setAccountTransactionRules({
      ...accountTransactionRules,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/AccountTransactionRule?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setAccountTransactionRules({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const checkForUseErp = () => {
    RequestHandler.get(`/AccountTransactionRule/CheckForUseErp`).then(
      (response) => {
        setIsUseForErp(response);
      }
    );
  };

  const onAddAccountTransactionRuleSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/AccountTransactionRule/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const onUpdateAccountTransactionRuleSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan kurallar güncellenemez.",
    });
  };

  const columns = [
    {
      title: "Kural Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Kural Metni",
      dataIndex: "key",
      key: "key",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Ek Kural Metni",
      dataIndex: "additionalKey",
      key: "additionalKey",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Açıklama",
      dataIndex: "replaceKey",
      key: "replaceKey",
      align: "left",
      width: "15%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Belge Tipi",
    //   dataIndex: "documentType",
    //   key: "documentType",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: isUseForErp ? "İşlem Tipi" : "Cari Sınıfı",
      dataIndex: isUseForErp ? "processType" : "firmClassName",
      key: isUseForErp ? "processType" : "firmClassName",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: isUseForErp ? "Erp Kodu" : "Cari Adı",
      dataIndex: isUseForErp ? "erpCode" : "firmName",
      key: isUseForErp ? "erpCode" : "firmName",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Muhasebe Kodu",
    //   dataIndex: "accountingCode",
    //   key: "accountingCode",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: "Referans Kodu",
      dataIndex: "referenceCode",
      key: "referenceCode",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Proje Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      width: "11%",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    // {
    //   title: "Sorumluluk Merkezi",
    //   dataIndex: "centerOfResponsibilityCode",
    //   key: "centerOfResponsibilityCode",
    //   align: "left",
    //   render: (text) => {
    //     if (!text) return "";

    //     return (
    //       <Tooltip title={text}>
    //         {text.substring(0, 25).length < 25
    //           ? text.substring(0, 25) + ""
    //           : text.substring(0, 25) + "..."}
    //       </Tooltip>
    //     );
    //   },
    // },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        accountTransactionRules.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const detailColumns = [
    {
      title: "Banka Hesabı",
      dataIndex: "tenantAccountName",
    },
    {
      title: "Hesap Hareketi İşlem Tipi",
      dataIndex: "transactionProcessTypeName",
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setAccountTransactionRules(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/AccountTransactionRule/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Kural Ekle
          </Button>
        </Col>
      </Row>

      <AccountTransactionRuleListFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={accountTransactionRules.data}
            loading={accountTransactionRules.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: accountTransactionRules.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addAccountTransactionRuleDrawer"
        title="Kural Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <AccountTransactionRuleAddForm
          onSuccess={onAddAccountTransactionRuleSuccess}
          isUseForErp={isUseForErp}
        />
      </Drawer>
      <Drawer
        id="updateAccountTransactionRuleDrawer"
        title="Kural Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <AccountTransactionRuleUpdateForm
          data={updateFormData}
          onSuccess={onUpdateAccountTransactionRuleSuccess}
          isUseForErp={isUseForErp}
        />
      </Drawer>
    </>
  );
};

export default AccountTransactionRuleList;
